import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
  Dataset,
  discoPrototypeStore,
} from 'client/app/apps/disco-prototype/dataStore/dexieStore';

type DatasetsTableProps = {
  datasets: Dataset[];
  usedDatasetIds: Set<string>;
};

const DatasetsTable: React.FC<DatasetsTableProps> = ({ datasets, usedDatasetIds }) => {
  const handleDelete = async (id: string) => {
    void discoPrototypeStore.deleteDataset(id);
  };

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell># Rows</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {datasets.map(ds => (
            <TableRow key={ds.id}>
              <TableCell>{ds.id}</TableCell>
              <TableCell>{ds.name}</TableCell>
              <TableCell>{ds.rows.length}</TableCell>
              <TableCell align="right">
                <IconButton
                  disabled={usedDatasetIds.has(ds.id)}
                  aria-label="delete"
                  color="error"
                  onClick={() => handleDelete(ds.id)}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DatasetsTable;
